/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, EventEmitter, Output } from '@angular/core';
import { LazyloadService, UNPLACEHOLDER } from '@dm/core';
import { GlobalDataService } from 'app/common/services';
import { type OEM } from 'app/common/types/oem';

import { HelpMenuStrService } from './../help-menu-str.service';

@Component({
    selector: 'app-about-info',
    templateUrl: './about-info.component.html',
    styleUrls: ['./about-info.component.scss'],
})

export class AboutInfoComponent implements OnInit {
    @Output() wrapClick = new EventEmitter();

    oem: OEM = (window as any).oem;

    i18nLabel = this.str.i18nLabel;

    isOem = this.oem.vendor !== 'huawei';

    isZh = this.str.language === 'zh';
    isJa = this.str.language === 'ja';
    logoUrl = this.isOem ? this.oem.path : undefined;

    systemInfo = this.globalDataService.getSystemInfo();

    version: string;

    websiteRes = (this.isZh ? this.oem.website_zh : this.oem.website_en);
    url = this.isOem ? this.websiteRes : this.i18nLabel.url;

    warnRes = (this.isZh ? this.oem.warn_zh : this.oem.warn_en);
    warning = this.isOem ? this.warnRes : this.i18nLabel.warning;

    copyrightRes = (this.isZh ? this.oem.copyright_zh : this.oem.copyright_en);
    copyright = this.isOem ? this.copyrightRes : this.i18nLabel.copyright;

    constructor(
        private globalDataService: GlobalDataService,
        private str: HelpMenuStrService,
        private lazyloadService: LazyloadService,
    ) { }

    ngOnInit(): void {
        this.initVersion();
    }

    initVersion(): void {
        if (!this.systemInfo) {
            this.version = UNPLACEHOLDER;

            return;
        }

        this.version = this.systemInfo.SoftwarePatch ?? this.systemInfo.pointRelease;
    }

    close(): void {
        this.lazyloadService.destroySelf(this);
    }
}
